import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { queryClient } from './lib/queryClient'
import './index.css'

// Auto-recover from stale chunk errors after deploys.
// When a lazy-loaded chunk 404s the browser gets HTML instead of JS.
// Mirror trade01's pattern: reload once (flag prevents infinite loop).
window.addEventListener('vite:preloadError', () => {
  const reloaded = sessionStorage.getItem('chunk-reload')
  if (!reloaded) {
    sessionStorage.setItem('chunk-reload', '1')
    window.location.reload()
  }
})
setTimeout(() => sessionStorage.removeItem('chunk-reload'), 8000)

// Register service worker (PWA install + push). No fetch interception.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silent — SW is non-critical, app works without it.
    })
  })
}

// The client itself lives in lib/queryClient so the account store can clear
// it when the scope changes.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
